import Hero from "../components/Hero";
import Highlights from "../components/Highlights";
import FeaturedProducts from "../components/FeaturedProducts";
import Testimonials from "../components/Testimonials";

export default function Home() {
  const data = {
    title: "Dessert Haven",
    content:
      "Welcome to your sweet escape—a haven of indulgent delights crafted to satisfy every craving. From decadent treats to irresistible creations, we’re here to sweeten every moment and make life a little more delicious.",
    destination: "/products",
    buttonLabel: "Check our Desserts",
  };

  return (
    <>
      {/* Hero Section */}
      <Hero data={data} />
      {/* Highlights Section */}
      <Highlights />
      {/* Featured Products Section */}
      <FeaturedProducts />
      <Testimonials />
    </>
  );
}
